import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.937 15.203c0 .61-.476 1.106-1.063 1.106-.586 0-1.062-.495-1.062-1.106v-2.55H3.442v2.55c0 .61-.475 1.106-1.063 1.106-.586 0-1.062-.495-1.062-1.106v-2.55c0-1.221.951-2.211 2.125-2.211h17.37c1.174 0 2.125.99 2.125 2.21zM19.749 20.39c0 1.22.952 2.21 2.126 2.21S24 21.61 24 20.39c0-1.221-.952-2.21-2.125-2.21s-2.126.989-2.126 2.21M10.187 20.39c0 1.22.951 2.21 2.125 2.21s2.126-.99 2.126-2.21c0-1.221-.952-2.21-2.126-2.21s-2.125.989-2.125 2.21M10.187 3.81c0 1.22.951 2.21 2.125 2.21s2.126-.99 2.126-2.21-.952-2.21-2.126-2.21-2.125.99-2.125 2.21M.623 20.39c0 1.22.952 2.21 2.125 2.21s2.126-.99 2.126-2.21c0-1.221-.952-2.21-2.126-2.21s-2.125.989-2.125 2.21"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.374 15.745c0 .611-.475 1.106-1.062 1.106s-1.062-.495-1.062-1.105v-6.41c0-.61.475-1.105 1.062-1.105s1.062.495 1.062 1.106z"
    }, null, -1)
  ]))]))
}
export default { render: render }